import { render } from "./ItemsSevenView.vue?vue&type=template&id=478a015b&scoped=true"
import script from "./ItemsSevenView.vue?vue&type=script&lang=js"
export * from "./ItemsSevenView.vue?vue&type=script&lang=js"

import "./ItemsSevenView.vue?vue&type=style&index=0&id=478a015b&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478a015b"]])

export default __exports__